/**************************************************
 * Nombre:       Home_Proceso_Adminision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import Tarjeta_Proceso_Adminision from "../../Tarjetas/Tarjeta_Proceso_Adminision";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import pasos from "../../../Recursos/pasos.png"
import Zoom from 'react-reveal/Zoom';
import {useNavigate} from "react-router-dom";

const Home_Proceso_Adminision = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}

            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                    spacing={11}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 7}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, color: theme.palette.primary.main, fontWeight: 600}}>
                                Proceso de Admisión
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 400}}>
                                Descubre lo que define nuestra excelencia académicaPasos sencillos para iniciar tu
                                futuro.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 16}}>
                                Inicia tu formación técnica hoy mismo siguiendo este proceso rápido y asegura tu éxito.
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Zoom>
                                        <Tarjeta_Proceso_Adminision item={item} index={index}/>
                                    </Zoom>
                                </Grid>
                            ))}

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Button
                                onClick={() => navigate('/Escuelas')}
                                sx={{color: '#fff', pt: 1, pb: 1}}>Ir a Oferta Educativa</Button>
                        </Grid>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                        <img src={pasos} width={'100%'} height={'auto'}/>
                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Proceso_Adminision

const items = [
    {
        nombre: 'Elige tu programa',
        descripcion: 'Explora nuestra oferta académica y selecciona el Técnico Laboral que mejor se adapte a tus metas profesionales',
        interno: true,
        camino: '/Escuelas'
    },
    {
        nombre: 'Registra tus datos',
        descripcion: 'Completa el formulario de inscripción con tu información personal y el programa de interés para iniciar el proceso',
        interno: false,
        camino: '/Escuelas'
    },
    {
        nombre: 'Entrega documentos',
        descripcion: 'Presenta los requisitos necesarios para validar tu perfil y formalizar tu ingreso a la institución',
        interno: false,
        camino: 'Entrega de documentos'
    },
    {
        nombre: 'Realiza tu matrícula',
        descripcion: 'Asegura tu cupo realizando el pago correspondiente y prepárate para transformar tu futuro con nosotros',
        interno: false,
        camino: 'Realizar el pago de mi formación'
    },
]